// extracted by mini-css-extract-plugin
export default {"equal":"eHUU26GhkXapizLG0Qsw"};